import React, { useState } from "react";
import UserManagement from "./UserManagement";
import NotificationManagement from "./NotificationManagement";
import ResourceManagement from "./ResourceManagement";
import NewsManagement from "./NewsManagement";
import EventManagement from "./EventManagement";
import ProductManagement from "./ProductManagement";
import OrderManagement from "./OrderManagement";
import FriendsManagement from "./FriendsManagement";
import SubscribersManagement from "./SubscribersManagement";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
      className="w-full"
    >
      {value === index && <div className="p-6">{children}</div>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `admin-tab-${index}`,
    "aria-controls": `admin-tabpanel-${index}`,
  };
}

const AdminPage: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="container mx-auto px-4 py-8 max-w-7xl">
      <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>

      <div className="bg-white rounded-lg shadow-md mb-8 overflow-hidden">
        <div className="border-b border-gray-200">
          <nav className="flex overflow-x-auto">
            <div className="flex space-x-8 pl-8">
              {[
                "Users",
                "Resources",
                "News",
                "Events",
                "Products",
                "Orders",
                "Notifications",
                "Friends",
                "Subscribers",
              ].map((label, index) => (
                <button
                  key={index}
                  onClick={() => handleChange(index)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                    value === index
                      ? "border-gold text-gold"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                  {...a11yProps(index)}
                >
                  {label}
                </button>
              ))}
            </div>
          </nav>
        </div>

        <TabPanel value={value} index={0}>
          <UserManagement />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <ResourceManagement />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <NewsManagement />
        </TabPanel>

        <TabPanel value={value} index={3}>
          <EventManagement />
        </TabPanel>

        <TabPanel value={value} index={4}>
          <ProductManagement />
        </TabPanel>

        <TabPanel value={value} index={5}>
          <OrderManagement />
        </TabPanel>

        <TabPanel value={value} index={6}>
          <NotificationManagement />
        </TabPanel>

        <TabPanel value={value} index={7}>
          <FriendsManagement />
        </TabPanel>

        <TabPanel value={value} index={8}>
          <SubscribersManagement />
        </TabPanel>
      </div>
    </div>
  );
};

export default AdminPage;
